<template>
  <div class="bg-parent">
      <img class="image_loader" src="../assets/images/bkg-loading.gif" alt="">
  </div>
</template>

<script>
export default {
    name: "Loading"
}
</script>

<style scoped>
    .bg-parent {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
        background-color: rgba(255,255,255,0.7);
        z-index: 1;
    }

    .bg-parent img {
        z-index: 2;
    }

    @media screen and (max-width: 580px) {
        .image_loader {
            max-width: 192px !important;
        }
    }


</style>